import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import FormGroup from '@material-ui/core/FormGroup';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';

import ReviewEditModal from '../../../../components/ReviewEditModal';
import * as api from '../../../../services/api/admin';

class Reviews extends Component {
  state = {
    isLoading: true,
    reviews: [],
    reviewUnderEdit: {},
    openReviewEditModal: false,
  };

  async componentDidMount() {
    try {
      this.setState({ isLoading: true });
      await this.fetchReviews();
    } catch (err) {
      console.error(err);
      this.props.enqueueSnackbar(
        'Unable to fetch reviews, please refresh the page to try again.'
      );
    } finally {
      this.setState({ isLoading: false });
    }
  }

  fetchReviews = async () => {
    const reviews = await api.fetchReviews();
    this.setState({ reviews });
  };

  onNewReview = async () => {
    this.setState({ openReviewEditModal: true, reviewUnderEdit: {} });
  };

  onEditReview = async review => {
    this.setState({ openReviewEditModal: true, reviewUnderEdit: review });
  };

  onSaveReview = async review => {
    const { enqueueSnackbar } = this.props;

    try {
      if (review.id) {
        await api.updateReview(review);
      } else {
        await api.createReview(review);
      }
      enqueueSnackbar('Review updated!');
      this.onClose();
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Unable to save review, please try again.');
    } finally {
      this.fetchReviews();
    }
  };

  onDeleteReview = async review => {
    const { enqueueSnackbar } = this.props;
    try {
      await api.deleteReview(review);
      enqueueSnackbar('Review deleted!');
      this.onClose();
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Unable to delete review, please try again.');
    } finally {
      this.fetchReviews();
    }
  };

  onClose = () => {
    this.setState({ openReviewEditModal: false, reviewUnderEdit: {} });
  };

  render() {
    const { classes } = this.props;
    const {
      isLoading,
      reviews,
      openReviewEditModal,
      reviewUnderEdit,
    } = this.state;

    if (isLoading) {
      return (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      );
    }

    return (
      <>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Provider</TableCell>
              <TableCell>Rating</TableCell>
              <TableCell>Descriptions</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reviews.map(review => (
              <TableRow key={review.id}>
                <TableCell width="300">
                  <Grid container alignItems="center">
                    <Grid item xs={12} xl={9}>
                      {review.providerName}
                    </Grid>
                  </Grid>
                </TableCell>
                <TableCell width="300">
                  <Grid container alignItems="center">
                    <Grid item xs={12} xl={9}>
                      {review.rating}
                    </Grid>
                  </Grid>
                </TableCell>
                <TableCell width="300">
                  <Grid container alignItems="center">
                    <Grid item xs={12} xl={9}>
                      {review.description}
                    </Grid>
                  </Grid>
                </TableCell>
                <TableCell>
                  <FormGroup row>
                    <IconButton onClick={() => this.onEditReview(review)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => this.onDeleteReview(review)}>
                      <DeleteIcon />
                    </IconButton>
                  </FormGroup>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <Grid
          container
          justifyContent="flex-end"
          classes={{ container: classes.actions }}
        >
          <Grid item xs={12} md={4} xl={2}>
            <Button
              fullWidth
              color="primary"
              variant="contained"
              onClick={this.onNewReview}
            >
              + Add Review
            </Button>
          </Grid>
        </Grid>

        {openReviewEditModal && (
          <ReviewEditModal
            open={openReviewEditModal}
            review={reviewUnderEdit}
            save={this.onSaveReview}
            onClose={this.onClose}
          />
        )}
      </>
    );
  }
}

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  actions: {
    marginTop: '2em',
  },
});

export default withSnackbar(withStyles(styles)(Reviews));
